"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
var _PagePicture = _interopRequireDefault(require("../../PagePicture/PagePicture"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.left-container .referenceGallery .image {\n  width: 131px; }\n\n.left-container .referenceGallery .picture-container {\n  padding-bottom: 16px; }\n\n.left-container .referenceGallery .title {\n  font-size: 20px; }\n\n.left-container .referenceGallery .corporate {\n  letter-spacing: 0.32px; }\n";
  const fileName = "ReferenceGallery_ReferenceGallery";
  const element = document.querySelector("style[data-sass-component='ReferenceGallery_ReferenceGallery']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ReferenceGallery = _ref => {
  let {
    label,
    items,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "referenceGallery sia-border-01-bottom sia-padding-03-top sia-padding-03-right sia-padding-02-left sia-padding-03-bottom"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "title sia-text-10  sia-margin-02-bottom"
  }, label['cms.newsletter.reference_gallery.title']), /*#__PURE__*/_react.default.createElement("div", null, items?.map((el, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "image"
    }, /*#__PURE__*/_react.default.createElement(_PagePicture.default, {
      src: `data:image/png;base64,${el.logo}`,
      aspectRatio: "131/59"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "corporate sia-text-01"
    }, el.corporate), /*#__PURE__*/_react.default.createElement("div", {
      className: "sia-margin-02-top"
    }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
      items: [{
        link: {
          title: el.title,
          original_url: `/reference-gallery/search/project/${el.reference_id}`
        }
      }],
      lang: lang,
      isCMS: false
    })));
  })));
};
var _default = exports.default = ReferenceGallery;